/* =========================================================
   ACTIVE LIFE x ELITE — CATALOG BEHAVIOR
   assets/catalog.js
   Vanilla JS only. No dependencies.
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Product page: thumbnail -> main image swap ---------- */
  document.querySelectorAll('[data-catalog-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-catalog-main-image]');
    var thumbs = gallery.querySelectorAll('[data-catalog-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!mainImg || !fullSrc) return;

        mainImg.style.opacity = '0';
        window.setTimeout(function () {
          mainImg.setAttribute('src', fullSrc);
          mainImg.setAttribute('alt', alt);
          mainImg.style.opacity = '1';
        }, 120);

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Mobile accordion navigation ---------- */
  document.querySelectorAll('[data-catalog-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var targetId = trigger.getAttribute('aria-controls');
      var panel = document.getElementById(targetId);
      if (!panel) return;

      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  });

  /* ---------- Mobile menu open/close ---------- */
  var menuToggle = document.querySelector('[data-catalog-menu-toggle]');
  var menuPanel = document.querySelector('[data-catalog-menu-panel]');
  if (menuToggle && menuPanel) {
    menuToggle.addEventListener('click', function () {
      var isOpen = menuPanel.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('catalog-menu-locked', isOpen);
    });
  }

  /* ---------- Collection filters (client-side, only when data supports it) ---------- */
  document.querySelectorAll('[data-catalog-filter-group]').forEach(function (group) {
    var buttons = group.querySelectorAll('[data-catalog-filter]');
    var grid = document.querySelector(group.getAttribute('data-filter-target'));
    if (!grid) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-catalog-filter');
        var isActive = btn.getAttribute('aria-pressed') === 'true';

        if (value === 'all') {
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
        } else {
          group.querySelector('[data-catalog-filter="all"]').setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-pressed', String(!isActive));
        }

        var activeValues = Array.prototype.slice
          .call(group.querySelectorAll('[aria-pressed="true"]'))
          .map(function (b) { return b.getAttribute('data-catalog-filter'); })
          .filter(function (v) { return v !== 'all'; });

        var cards = grid.querySelectorAll('[data-catalog-card]');
        cards.forEach(function (card) {
          if (activeValues.length === 0) {
            card.hidden = false;
            return;
          }
          var cardTags = (card.getAttribute('data-filter-tags') || '').split('|');
          var matches = activeValues.some(function (v) { return cardTags.indexOf(v) !== -1; });
          card.hidden = !matches;
        });
      });
    });
  });

});